import { render } from "./NotificationListPage.vue?vue&type=template&id=bb113de4"
import script from "./NotificationListPage.vue?vue&type=script&lang=ts"
export * from "./NotificationListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script